import { useState } from 'react';

import BankConnection from './BankConnection';
import BankStatements from './BankStatements';
import { useFinancialVerification } from './FinancialVerificationContext';

export default function BankVerificationMethod() {
  const { shouldShowPlaidConnection } = useFinancialVerification();
  const [currentView, setCurrentView] = useState(
    shouldShowPlaidConnection ? 'bank-connection' : 'bank-statements'
  );

  const renderCurrentView = () => {
    switch (currentView) {
      case 'bank-connection':
        if (!shouldShowPlaidConnection) {
          return null;
        }

        return (
          <BankConnection
            onUploadBankStatements={() => setCurrentView('bank-statements')}
          />
        );
      case 'bank-statements':
        return (
          <BankStatements
            onBankConnection={() => setCurrentView('bank-connection')}
          />
        );
      default:
        return (
          <BankConnection
            onUploadBankStatements={() => setCurrentView('bank-statements')}
          />
        );
    }
  };

  return <div>{renderCurrentView()}</div>;
}
